import { ColumnsType } from 'antd/lib/table'
import commomColumns, { columnBlockUser } from './commomDataTable'
import { IColumns } from 'egi/types'

const columns = ({ blockUser }: IColumns): ColumnsType<Object> => [
  ...commomColumns,
  columnBlockUser(blockUser)
]

export default columns
